import React from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ModLogin } from "@/components/mod/ModLogin";
import { ModDashboard } from "@/components/mod/ModDashboard";

export default function Moderator() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-zinc-950">
        <Loader2 className="animate-spin text-zinc-600" size={26} />
      </div>
    );
  }
  return user ? <ModDashboard /> : <ModLogin />;
}
